export { LastMonthPay } from './LastMonthPay';
